var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[{ 
		'box-layout': _vm.boxLayout,
		'rtl-layout': _vm.rtlLayout
	}],attrs:{"dark":_vm.darkMode,"id":"inspire"}},[_c('router-view'),_c('snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }